import { MessageSenders } from 'api/support'

export const isSenderSystem = (sender) => sender === MessageSenders.SYSTEM

export const isSenderUser = (sender) => sender === MessageSenders.USER

export const isSenderLE = (sender) => sender === MessageSenders.AGENT || sender === MessageSenders.CHATBOT
